import React, { useState, useEffect } from 'react'
import { PageHeader, Button, Table, Skeleton, Popconfirm, Modal } from 'antd'
import { useQuery } from '@apollo/react-hooks'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'

import ResultError from '@packages/ResultError'
import { EQUIPMENTS_ICON } from '@constants/IconsConstants'
import { useColumnFilterProps } from '@utils/columnFilter'
import { getEquipmentsQuery } from '@graphql/queries'
import { useUpdateEquipment, useDeleteEquipment } from '@graphql/mutations'

import EditableCell from '../../EditableCell'
import ManageEquipmentForm from '../ManageEquipmentForm'

const tableProps = {
  size: 'middle',
  pagination: false,
}
const newButtonProps = {
  type: 'primary',
  icon: <PlusOutlined />,
  key: 'newEquipment',
}

function ManageEquipmentTable() {
  const [equipmentsData, setEquipmentsData] = useState(false)
  const [formModalVisible, setFormModalVisible] = useState(false)
  const { error, data } = useQuery(getEquipmentsQuery)
  const [updateEquipment] = useUpdateEquipment()
  const [deleteEquipment] = useDeleteEquipment()
  const useFilterField = field => useColumnFilterProps(field)
  const toggleFormModal = () => setFormModalVisible(!formModalVisible)

  useEffect(() => {
    if (data) setEquipmentsData(data.findManyEquipment)
  }, [data])

  const handleSave = data => {
    const { id, name } = data
    const newData = [...equipmentsData]
    const index = newData.findIndex(item => item.id === data.id)
    const item = newData[index]

    newData.splice(index, 1, { ...item, ...data })

    if (JSON.stringify(newData) !== JSON.stringify(equipmentsData)) {
      updateEquipment({
        variables: {
          id,
          data: {
            name: { set: name },
          },
        },
      })

      setEquipmentsData(newData)
    }
  }

  const handleDelete = id => {
    deleteEquipment({
      variables: { id },
      refetchQueries: ['GetEquipmentsQuery'],
    })
  }
  const columns = [
    {
      dataIndex: 'name',
      title: 'Nome',
      editable: true,
      ...useFilterField('name'),
    },
    {
      align: 'center',
      render: (value, { id, name }) => (
        <Popconfirm
          title={`Tem a certeza que quer eliminar ${name} ?`}
          onConfirm={() => handleDelete(id)}
          okText="Sim"
          cancelText="Não"
        >
          <DeleteOutlined />
        </Popconfirm>
      ),
    },
  ]
  const mappedColumns = columns.map(col => {
    if (!col.editable) return col

    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    }
  })

  return (
    <>
      <Modal
        title="Novo equipamento"
        visible={formModalVisible}
        onCancel={() => toggleFormModal()}
        footer={null}
      >
        <ManageEquipmentForm afterSubmit={() => toggleFormModal()} />
      </Modal>

      <PageHeader
        title="Equipamentos"
        avatar={{ src: EQUIPMENTS_ICON }}
        extra={[
          <Button {...newButtonProps} onClick={() => toggleFormModal()}>
            Novo equipamento
          </Button>,
        ]}
      />

      {error && <ResultError />}

      <Skeleton loading={!error && !equipmentsData} active>
        {equipmentsData && (
          <Table
            components={EditableCell.Components}
            columns={mappedColumns}
            dataSource={equipmentsData}
            rowKey={({ id }) => id}
            rowClassName={() => 'editable-row'}
            {...tableProps}
          />
        )}
      </Skeleton>
    </>
  )
}

export default ManageEquipmentTable
